/** 学生详情页的「成绩单」面板:各课程学期成绩 + 两套 GPA(博颂 2026-09-21)。 */
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { useTranscript } from "../../api/gpa";

export function TranscriptPanel({ studentId }: { studentId: string }): JSX.Element | null {
  const { t } = useTranslation();
  const tr = useTranscript(studentId);
  if (!tr.data || tr.data.courses.length === 0) return null;
  const d = tr.data;
  return (
    <section className="mb-6 rounded-lg border border-slate-200 bg-white p-6" data-testid="gpa-transcript">
      <div className="mb-3 flex flex-wrap items-baseline justify-between gap-2">
        <h2 className="text-sm font-semibold uppercase tracking-wide text-slate-600">{t("gpa.transcript.title")}</h2>
        <div className="flex gap-4 text-sm">
          <span>{t("gpa.transcript.gpa")}: <b className="text-sky-700">{d.gpa ?? "—"}</b>{d.gpa !== null && <span className="text-xs text-slate-400"> / {t("gpa.transcript.credits", { n: d.gpa_credits })}</span>}</span>
          {d.conduct && d.gpa !== null && <span title={t("gpa.transcript.adjustedHint", { total: d.conduct.total, coef: d.conduct.coefficient.toFixed(2) })}>{t("gpa.transcript.adjusted")}: <b className="text-violet-700">{d.gpa_adjusted ?? "—"}</b> <span className="text-xs text-slate-400">(× {d.conduct.coefficient.toFixed(2)})</span></span>}
          <span>{t("gpa.transcript.weightedAvg")}: <b className="text-emerald-700">{d.weighted_average ?? "—"}</b></span>
          <span>{t("gpa.transcript.simpleAvg")}: <b>{d.simple_average ?? "—"}</b></span>
        </div>
      </div>
      <table className="w-full text-sm">
        <thead className="text-xs text-slate-500"><tr><th className="py-1 text-left">{t("gpa.transcript.course")}</th><th className="py-1 text-left">{t("gpa.transcript.semester")}</th><th className="py-1 text-right">{t("gpa.transcript.creditsCol")}</th><th className="py-1 text-right">{t("gpa.transcript.score")}</th><th className="py-1 text-center">GPA</th>{d.courses.some((c) => c.domestic_label) && <th className="py-1 text-center">{t("gpa.transcript.domestic")}</th>}</tr></thead>
        <tbody>
          {d.courses.map((c) => (
            <tr key={c.class_id} className="border-t border-slate-100">
              <td className="py-1.5"><Link to={`/classes/${c.class_id}/grades`} className="text-sky-600 hover:underline">{c.class_name}</Link></td>
              <td className="py-1.5 text-slate-500">{c.semester}</td>
              <td className="py-1.5 text-right">{c.credits ?? "—"}</td>
              <td className="py-1.5 text-right font-medium">{c.final_score ?? "—"}</td>
              <td className="py-1.5 text-center">{c.gpa_label ? `${c.gpa_label} · ${c.gpa_points}` : "—"}</td>
              {d.courses.some((x) => x.domestic_label) && <td className="py-1.5 text-center">{c.domestic_label ?? "—"}</td>}
            </tr>
          ))}
        </tbody>
      </table>
    </section>
  );
}
